export default __webpack_public_path__ + "static/media/chicken.2cca3c66.png";